module.exports = __webpack_public_path__ + "static/img/pasteur.71ff606.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/pasteur.gif
// module id = kmCR
// module chunks = 0